import { RefObject, useEffect } from 'react'
import { isTouchDevice } from '../utils/browserDetect'

export function useVirtualKeyboard(inputRefs: RefObject<HTMLElement | null>[]) {
  const lockScrollByViewport = () => {
    const vh = window.visualViewport?.height ?? window.innerHeight
    document.documentElement.style.height = `${vh}px`
    document.body.style.height = `${vh}px`
    document.documentElement.style.overflow = 'hidden'
    document.body.style.overflow = 'hidden'
  }

  const unlockScroll = () => {
    document.documentElement.style.height = ''
    document.body.style.height = ''
    document.documentElement.style.overflow = ''
    document.body.style.overflow = ''
  }

  useEffect(() => {
    if (!isTouchDevice()) {
      return
    }

    const handleFocus = () => {
      lockScrollByViewport()
    }

    const handleBlur = () => {
      unlockScroll()
    }

    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      const target = event.target as Node
      const isClickOnInput = elements.some(element => element.contains(target))

      if (!isClickOnInput) {
        elements.forEach(element => {
          if (document.activeElement === element) {
            element.blur()
          }
        })
      }
    }

    const elements: HTMLElement[] = []

    // Add event listeners to all input refs
    inputRefs.forEach(ref => {
      if (ref.current) {
        elements.push(ref.current)
        ref.current.addEventListener('focus', handleFocus)
        ref.current.addEventListener('blur', handleBlur)
      }
    })

    // Add click outside listeners
    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('touchstart', handleClickOutside)

    return () => {
      // Cleanup event listeners
      elements.forEach(element => {
        element.removeEventListener('focus', handleFocus)
        element.removeEventListener('blur', handleBlur)
      })

      // Cleanup click outside listeners
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('touchstart', handleClickOutside)

      // Reset body height on cleanup
      unlockScroll()
    }
  }, [inputRefs])
}
